import { Button, Col, Form, Input, Row, Upload, message } from "antd";
import { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaCamera } from "react-icons/fa";
import { PROFILE, UPLOADS_URL } from "../../config/constants/api";
import { useDispatch, useSelector } from "react-redux";
import { Put } from "../../config/api/put";
import { addUser } from "../../redux/slice/authSlice";
import swal from "sweetalert";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    message.error("Invalid Uplaod, You can only upload image files!");
  }
  return isImage;
};

const UpdateProfile = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageObject, setImageObject] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const onFinish = (values) => {
    const { FirstName, LastName, Phone } = values;
    const formValuesChanged = () => {
      return (
        userData?.firstName !== FirstName ||
        userData?.lastName !== LastName ||
        userData?.phone !== Phone ||
        imageObject
      );
    };
    if (formValuesChanged()) {
      let data = new FormData();
      if (imageObject) {
        data.append("image", imageObject);
      }
      if (FirstName) {
        data.append("firstName", FirstName);
      }
      if (LastName) {
        data.append("lastName", LastName);
      }
      if (Phone) {
        data.append("phone", Phone);
      }

      Put(PROFILE.updateMyProfile, token, data, {}, "multipart")
        .then((response) => {
          if (response.status) {
            dispatch(addUser({ user: response?.data, token: token }));
            form.resetFields();
            swal("Success", "Profile Updated Successfully", "success");
            navigate("/profile");
          }
        })
        .catch((err) => {
          console.log("Error", err);
          swal("Error", err?.response?.data?.message, "error");
        });
    } else {
      swal("System Alert", "No Changes Detected", "error");
      return;
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      FirstName: userData?.firstName,
      LastName: userData?.lastName,
      Email: userData?.email,
      Phone: userData?.phone,
    });
    //eslint-disable-next-line
  }, []);
  // const onChange = (checked) => {
  //   console.log(`switch to ${checked}`);
  // };

  // const prefixSelector = (
  //   <Form.Item name="prefix" noStyle>
  //     <Select style={{ width: 70 }} defaultValue="86">
  //       <Option value="86">+86</Option>
  //       <Option value="87">+87</Option>
  //     </Select>
  //   </Form.Item>
  // );

  const handleChangepro = (info) => {
    setLoading(true);
    getBase64(
      info?.fileList[info?.fileList?.length - 1]?.originFileObj,
      (url) => {
        setImageObject(
          info?.fileList[info?.fileList?.length - 1]?.originFileObj
        );
        setLoading(false);
        setImageUrl(url);
      }
    );
  };
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-start items-center mt-8">
          <IoIosArrowRoundBack
            onClick={() => navigate(-1)}
            className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px]"
          />
          <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
            Update Profile
          </h3>
        </div>
        <div
          className="bg-white rounded-lg py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row justify="center">
            <Col xxl={14} md={18} xs={22}>
              <Form
                form={form}
                name="editUser"
                onFinish={onFinish}
                layout="vertical"
                className="w-full px-8 max-xl:px-2"
              >
                <Row justify="center" gutter={[32, 0]}>
                  <Col lg={24} sm={24} xs={24}>
                    <div className="wrapper-group-1000001858 text-center">
                      <>
                        <Upload
                          name="image"
                          showUploadList={false}
                          style={{ position: "relative" }}
                          onChange={handleChangepro}
                          beforeUpload={beforeUpload}
                        >
                          {" "}
                          <div
                            style={{
                              height: "300px",
                              // border: "1px solid gray",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              width: "100%",
                              objectFit: "cover",
                            }}
                          >
                            {imageUrl ? (
                              <img
                                src={imageUrl}
                                alt="avatar"
                                style={{
                                  width: "100%",
                                  maxHeight: "300px",
                                }}
                              />
                            ) : (
                              <img
                                src={UPLOADS_URL + userData?.image}
                                alt="avatar"
                                style={{
                                  width: "100%",
                                  maxHeight: "300px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  filter: "blur(1px)",
                                }}
                              />
                            )}
                            <FaCamera
                              style={{
                                position: "absolute",
                                color: "rgb(0,127,202)",
                                fontSize: "25px",
                              }}
                            />
                          </div>{" "}
                        </Upload>
                      </>
                    </div>

                    {/* <div className="flex flex-col items-center justify-center md:py-8">
                      <img src={ImageUrl("profile-1.png")} alt="profile" />
                      <div className="flex justify-center items-center p-2 bg-customGold rounded-full mt-[-20px] ml-[50px]">
                        <BsCameraFill size={16} className="text-white" />
                      </div>
                    </div> */}
                  </Col>
                  <Col lg={12} sm={24} xs={24}>
                    <Form.Item
                      name="FirstName"
                      label={
                        <p className="font-euclid text-sm text-black font-semibold">
                          First Name
                        </p>
                      }
                     
                    >
                      <Input
                        placeholder="Enter First Name"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="text"
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={12} sm={24} xs={24}>
                    <Form.Item
                      name="LastName"
                      label={
                        <p className="font-euclid text-sm text-black font-semibold">
                          Last Name
                        </p>
                      }
                      
                    >
                      <Input
                        placeholder="Enter Last Name"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="text"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row justify="center" gutter={[32, 0]}>
                  <Col lg={12} sm={24} xs={24}>
                    <Form.Item
                      name="Phone"
                      label={
                        <p className="font-euclid text-sm text-black font-semibold">
                          Phone Number
                        </p>
                      }
                  
                    >
                      <Input
                        // addonBefore={prefixSelector}
                        placeholder="Enter Phone Number"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="number"
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={12} sm={24} xs={24}>
                    <Form.Item
                      name="Email"
                      label={
                        <p className="font-euclid text-sm text-black font-semibold">
                          Email Address
                        </p>
                      }
                    >
                      <Input
                        placeholder="Enter Email Address"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="email"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row justify="center">
                  <Col lg={12}>
                    <Form.Item className="self-center text-center mt-8">
                      <div className="flex flex-wrap justify-center gap-4">
                        <Button
                          htmlType="submit"
                          className="uppercase bg-button hover:bg-white hover:border-customGold hover:border-2 font-euclid font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm"
                        >
                          {loading ? "LOADING..." : "Update Profile"}
                        </Button>
                        <Button
                          type="default"
                          className="uppercase bg-white border border-[#1A1A1A] font-euclid font-bold text-[#1A1A1A] px-14 h-[50px] text-center text-sm hover:bg-[#1A1A1A] hover:text-white"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default UpdateProfile;
